<template>  
  <nav class="navbar navbar-trasparent">
    <div class="row d-none d-lg-flex width-100 k">
        <div class="col-3 d-none d-md-flex"> 
            <h1>
                <router-link to="/">
                    <img src="../assets/images/logo_myiptv.png" class="img-fluid" >
                    <span class="align-items-end text-white"> IPTV</span>
                </router-link>
            </h1>
        </div>
        <div class="col-3 d-flex d-sm-none"> 
            <h3>
                <router-link to="/">
                    <img src="../assets/images/logo_myiptv.png" class="img-fluid" >
                    <span class="align-items-end text-white"> IPTV</span>
                </router-link>
            </h3>
        </div>
        
        <div class="col-8 d-none d-md-flex align-items-center justify-content-end">
          <div class="d-none d-lg-block w-50 row">
              <div class="col-12">
                  <search :back="false"></search>   
              </div>
              
          </div>
          <div class="d-block d-lg-none row">
              <div class="col-12">
                  <search :back="false"></search>   
              </div>
              
          </div>
        </div>

        <div class="col-7 d-flex d-md-none align-items-center justify-content-end">
          <div class="d-none d-lg-block w-50 row">
              <div class="col-12">
                  <search :back="false"></search>   
              </div>
              
          </div>
          <div class="d-block d-lg-none row">
              <div class="col-12">
                  <search :back="false"></search>   
              </div>
              
          </div>
        </div>
    
        <div class="col-1 d-none d-md-flex align-items-center justify-content-end">
            <button type="button" class="px-2 button-search" v-on:click="logout()"> <ficon :icon="['fas', 'power-off']" style="font-size:1.7em;"></ficon></button>
        </div>
        
        
        <div class="col-2 d-flex d-sm-none align-items-center justify-content-end">
            <button type="button" class="px-1 pb-3 button-search" v-on:click="logout()"><ficon icon="power-off"></ficon><br></button>
        </div>
        
        
    </div>
    <!-- MOD. RESPONSIVE -->
    <div class="d-lg-none d-md-flex align-items-center justify-content-center w-100">
      <div class="row">
        <div class="col-md-12 d-flex justify-content-center"> 
            <h3>
                <router-link to="/">
                    <img src="../assets/images/logo_myiptv.png" class="img-fluid" ><br>
                    <span class="align-items-end text-white"> IPTV</span>
                </router-link>
            </h3>
        </div>
        <div class="col-md-12 align-items-center justify-content-center pr-none">
           <search :back="false"></search>   
        </div>
      </div>
      
    </div>
  </nav>    
</template>

<script>

import { mapActions } from 'vuex'
import Search from '@/components/Search.vue'

export default {
  name: 'MainHeader',
  data: function() {
    return  {
      
    };
  },
  props: {    
  },
  methods: {
    ...mapActions('User', [
      'logout'
    ]),    
  },
  components: {
    Search
  },
  computed: {    
  }
}
</script>
